<template>
  <div>
    <router-link
    :to="{name: 'ViewRubricVersion', params: {rid: params.data.rubricId , vid: params.data.id }}">
      Version {{ params.data.version }}
    </router-link>
  </div>
</template>

<script lang="js">
import Vue from 'vue';

export default Vue.extend({
  data: function () {
    return {
    }
  }
})
</script>